import Link from "next/link";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { MdChevronRight } from "react-icons/md";
import styles from "./Breadcrumbs.module.css";

const SKIP_SEGMENTS = new Set(["in", "api", "index"]);

function formatLabel(segment = "") {
  return String(segment)
    .replace(/\.[^/.]+$/, "")
    .split(/[-_]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export default function Breadcrumbs({ className = "" }) {
  const router = useRouter();

  const items = useMemo(() => {
    const pathOnly = (router.asPath || "/").split("?")[0].split("#")[0];
    const parts = pathOnly.split("/").filter(Boolean);

    const crumbs = [{ label: "Home", href: "/" }];
    let href = "";

    parts.forEach((part) => {
      href += `/${part}`;
      if (SKIP_SEGMENTS.has(part.toLowerCase())) return;

      crumbs.push({
        label: formatLabel(part),
        href,
      });
    });

    return crumbs.map((item, index) => ({
      ...item,
      isLast: index === crumbs.length - 1,
    }));
  }, [router.asPath]);

  if (items.length <= 1) return null;

  return (
    <nav
      className={`standard-padding ${styles.breadcrumb} ${className}`.trim()}
      aria-label="Breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = item.isLast;
        const disabled = item.href === "/page" || item.href === "/place" || item.href === "/in/page" || item.href === "/in/place"
        return (
          <span key={`${item.href}-${index}`} className={styles.item}>
            {index > 0 ? (
              <span className={styles.separator} aria-hidden="true">
                <MdChevronRight size={18} />
              </span>
            ) : null}
            {isLast ? (
              <span className={styles.current} aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link
                href={item.href}
                onClick={(e) => {
                  if (disabled) {
                    e.preventDefault();
                  }
                }}
                className={`${styles.link} ${disabled ? styles.disabledLink : ""}`}
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
